import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically handle the form submission
    console.log('Form submitted:', formData);
    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
    alert('Thank you for your message. We will get back to you soon!');
  };

  return (
    <div className="contact-page">
      <Navigation />
      <div className="contact-content">
        <div className="contact-header">
          <Link to="/">
            <img src={require('../assets/FH_Logo-on-LG-Green.png')} alt="Forage Hill Cafe" className="contact-logo" />
          </Link>
          <h2>Contact Us</h2>
        </div>

        <div className="contact-grid">
          {/* Business Information */}
          <div className="business-info">
            <div className="info-content">
              <h3>Visit Us</h3>
              <p>87a Mclaughlins Road</p>
              <p>Wiri, 2104</p>
              <p>Auckland, New Zealand</p>
              
              <h3>Opening Hours</h3>
              <p>Monday - Friday: 6:00 AM - 3:30 PM</p>
              <p>Saturday - Sunday: Closed</p>
              
              <h3>Get in Touch</h3>
              <p>Phone: 09 217 2768</p>
              <p>Email: foragehill@gmail.com</p>
            </div>

            <div className="map-container">
              <iframe 
                title="Forage Hill Cafe Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3188.893555273404!2d174.85659631547897!3d-36.98661797990287!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6d0d4e1f6b4b4b4b%3A0x1c1c1c1c1c1c1c1c!2s87A%20McLaughlins%20Rd%2C%20Wiri%2C%20Auckland%202104!5e0!3m2!1sen!2snz!4v1625000000000!5m2!1sen!2snz"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>

          {/* Contact Form */}
          {/* <div className="contact-form-container">
            <h3>Send Us a Message</h3>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                ></textarea>
              </div>

              <button type="submit" className="submit-button">Send Message</button>
            </form>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Contact;
